var hotjar = require('./src/react-hotjar');

module.exports = {
	hotjar: {
		initialize: function initialize(id, sv) {
			hotjar(id, sv);
		}
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/react-hotjar/index.js
// module id = 572
// module chunks = 0